import React, { useState } from 'react';
import '../../entrydoor.css';

const SillSize = ({ value, onChange, label = 'SillSize:' }) => {
    const [selectedSillSize, setSelectedSillSize] = useState(value || '6 5/8"');

    const handleSillSizeChange = (e) => {
        setSelectedSillSize(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label  style={{ display: "none" }} htmlFor="SillSize">{label}</label>
            <select style={{ display: "none" }}
                id="SillSize"
                value={selectedSillSize}
                onChange={handleSillSizeChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value='4 5/8"'>{selectedSillSize === '4 5/8"' ? '4 5/8" ✔' : '4 5/8"'}</option>
                <option value='5 3/4"'>{selectedSillSize === '5 3/4"' ? '5 3/4" ✔' : '5 3/4"'}</option>
                <option selected value='6 5/8"'>{selectedSillSize === '6 5/8"' ? '6 5/8" ✔' : '6 5/8"'}</option>
                <option value='7 1/4"'>{selectedSillSize === '7 1/4"' ? '7 1/4" ✔' : '7 1/4"'}</option>
                <option value='7 3/4"'>{selectedSillSize === '7 3/4"' ? '7 3/4" ✔' : '7 3/4"'}</option>
                <option value='8 5/8"'>{selectedSillSize === '8 5/8"' ? '8 5/8" ✔' : '8 5/8"'}</option>
                <option value='9 3/4"'>{selectedSillSize === '9 3/4"' ? '9 3/4" ✔' : '9 3/4"'}</option>
                <option value='10 5/8"'>{selectedSillSize === '10 5/8"' ? '10 5/8" ✔' : '10 5/8"'}</option>
            </select>
        </div>
    );
};

export default SillSize;
